import { render } from "./SelectLanguage.vue?vue&type=template&id=e00248e8&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"

import "@/assets/scss/_selectLanguage.scss?vue&type=style&index=0&id=e00248e8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00248e8"]])

export default __exports__